import React, { Component } from 'react'
import { connect } from 'react-redux'
import { authService, settingBillingRateService, settingBillingCategoryService } from '../../../../services'
import moment from 'moment'
import { Link } from 'react-router-dom'

// UI
import { Button, FullModal, Pager, SectionTitle, List } from '../../../../components'
import Form from 'antd/lib/form'
import Switch from 'antd/lib/switch'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Skeleton from 'antd/lib/skeleton'
import TimePicker from 'antd/lib/time-picker'
import Popconfirm from 'antd/lib/popconfirm'
import message from 'antd/lib/message'

import './styles.css'
import notify from '../../../../components/Notification'
import BillingRateRow from './row'

const pageSize = 20
const { Item: FormItem } = Form

const settingTitle = 'Billing Rate Set'
const settingType = 'gender'

export class SettingBillingRates extends Component {
  constructor (props) {
    super(props)
    this.state = {
      billingRates: [],
      categories: [],
      categoryRates: [],
      currentPage: 1,
      defaultBillingRates: [],
      defaultCategoryRates: [],
      filter: {},
      list: [],
      modal: {
        item: { link: {} },
        show: false
      },
      modalShow: false,
      searchText: '',
      selectedItem: { _id: null },
      sort: {},
      total: 0
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.onAdd !== prevState.onAdd) {
      return { onAdd: nextProps.onAdd || false }
    }
  }

  componentDidMount () {
    const { currentPage } = this.state
    this.fetchBillingRates({ currentPage })
    this.fetchBillingCategory()
  }

  componentDidUpdate (prevProps, prevState) {
    const { defaultBillingRates, defaultCategoryRates, onAdd } = this.state
    if (onAdd && onAdd !== prevState.onAdd) {
      const billingRates = (Array.isArray(defaultBillingRates) ? defaultBillingRates : []).slice(0)

      for (let i = 0; i < billingRates.length; i++) {
        billingRates[i].value = 0
      }
      this.setState({ billingRates, categoryRates: defaultCategoryRates })
    }
  }

  fetchBillingRates = async ({ loading = false, currentPage = 1, filter = {}, sort = {}, searchText }) => {
    try {
      this.setState({ currentPage, loading: loading })
      const settings = await settingBillingRateService.listByPage(currentPage, pageSize, filter, sort, searchText)

      this.setState({ list: settings.list, loading: false, total: settings.total })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load Billing Rate Set successfully. Please try again later.')
    }
  }

  fetchBillingCategory = async () => {
    try {
      const categories = await settingBillingCategoryService.listByPage(1, 0)
      const billingRates = []
      const categoryRates = []

      for (let i = 0; i < categories.list.length; i++) {
        const category = categories.list[i]
        const rates = []
        for (let j = 0; j < 8; j++) {
          // populate normal hours
          rates.push({ category_id: category.id, day: `n${j + 1}`, value: 0 })
          // populate after hours
          rates.push({ category_id: category.id, day: `a${j + 1}`, value: 0 })

          billingRates.push({ category_id: category.id, day: `n${j + 1}`, value: 0 })
          billingRates.push({ category_id: category.id, day: `a${j + 1}`, value: 0 })
        }

        categoryRates.push({ id: category.id, name: category.name, rates })
      }

      // console.log('defaultBillingRates', billingRates)

      this.setState({ categories: categories.list, defaultBillingRates: billingRates, defaultCategoryRates: categoryRates })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load category successfully. Please try again later.')
    }
  }

  fetchRateSet = async (id) => {
    try {
      const categoryRates = await settingBillingRateService.get(id)
      const billingRates = []

      for (let i = 0; i < categoryRates.categories.length; i++) {
        const rateSet = categoryRates.categories[i]
        for (let j = 0; j < rateSet.rates.length; j++) {
          const rate = rateSet.rates[j]
          billingRates.push({ category_id: rateSet.id, day: rate.day, value: rate.value })
        }
      }

      this.setState({ categoryRates: categoryRates.categories, billingRates })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load rate set successfully. Please try again later.')
    }
  }

  hideModal = () => {
    const { form } = this.props
    const { modal } = this.state
    const { resetFields } = form
    resetFields()
    modal.item = { link: {} }
    modal.show = false
    this.setState({ modal, selectedItem: {} })
    this.props.onComplete()
  }

  showModal = () => {
    const { modal } = this.state
    modal.show = true
    this.setState({ modal })
  }

  handleSave = () => {
    const { form } = this.props
    const { validateFields } = form
    const { billingRates, selectedItem } = this.state

    validateFields(async (errors, values) => {
      if (!errors) {
        const { id } = selectedItem
        const { modal } = this.state
        const { item } = modal
        values.rates = billingRates
        this.setState({ loadingForm: true })

        try {
          let response

          if (id) {
            response = await settingBillingRateService.save(id, values)
          } else {
            response = await settingBillingRateService.add(values)
          }

          this.setState({ loadingForm: false })

          if (response.id) {
            const { id } = response
            modal.item = { ...item, ...values, id }

            this.setState({ modal })
            notify.success('Saved successfully', `${settingTitle} saved successfully.`)
            this.fetchBillingRates({ currentPage: 1 })
            this.hideModal()
          } else {
            notify.error('Unable to save successfully', `Unable to save ${settingType} successfully. Please try again later.`)
          }
        } catch (e) {
          notify.error('Unable to save successfully', `Unable to save ${settingType} successfully. Please try again later.`)
          this.setState({ loadingForm: false })
        }
      }
    })
  }

  handleEdit ({ id, name, active, normal_hours_end, normal_hours_start, after_hours_end, after_hours_start, km_billing_rate }) {
    this.fetchRateSet(id)
    this.setState({ selectedItem: { id, name, normal_hours_end, normal_hours_start, after_hours_end, after_hours_start, active, km_billing_rate } })
    this.showModal()
  }

  async handleDelete (id) {
    const res = await settingBillingRateService.remove(id)

    if (res) {
      message.success('Deleted successfully', `${settingType} deleted successfully`)
      this.fetchBillingRates({ currentPage: 1 })
    }
  }

  setBillingRate (category, day, value) {
    const { billingRates } = this.state
    let isExist = false

    for (let i = 0; i < billingRates.length; i++) {
      const rate = billingRates[i]
      if (rate.category_id === category && rate.day === day) {
        rate.value = parseFloat(value)
        isExist = true
        break
      }
    }

    if (!isExist) {
      billingRates.push({ category_id: category, day, value })
    }

    this.setState({ billingRates })
  }

  removeBillingRate (category) {
    const { billingRates, categoryRates } = this.state
    const newBillingRates = billingRates.filter(r => r.category_id !== category)
    const newCategoryRates = categoryRates.filter(r => r.id !== category)

    this.setState({ billingRates: newBillingRates, categoryRates: newCategoryRates })
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  render () {
    const { categories, categoryRates, currentPage, defaultCategoryRates, list, loading, loadingForm, modal, selectedItem, total } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form

    const formItemLayout = {
      labelCol: { sm: 6, md: 6, lg: 4 },
      wrapperCol: { sm: 14, md: 14, lg: 18 }
    }

    const formItemTimeLayout = {
      labelCol: { sm: 6, md: 6, lg: 10 },
      wrapperCol: { sm: 14, md: 14, lg: 12 }
    }

    const columns = [
      {
        title: 'Name',
        width: 16,
        key: 'name'
      },
      {
        title: 'Enable',
        width: 6,
        render: ({ id, active }) => <div style={{ fontSize: '11pt' }}>{ active ? <Icon type='check-circle' theme='filled' /> : null } { this.hasAccess('readBillingRate') && !this.hasAccess('updateBillingRate') ? <Col md={1}>
          <Link to={`/settings/billing-rates/${id}`}><div><Icon type='eye' /></div></Link>
        </Col> : null }</div>
      },
      {
        title: '',
        width: 1,
        render: ({ id }) => this.hasAccess('updateBillingRate') ? <Link to={`/settings/billing-rates/${id}`}><div><Icon type='form' /></div></Link> : null
      },
      {
        title: '',
        width: 1,
        render: ({ id }) => this.hasAccess('deleteBillingRate') ? <Popconfirm
          title='Confirm to delete this?'
          onConfirm={(e) => this.handleDelete(id)}
          okText='Yes'
          cancelText='No'
        ><Icon type='delete' />
        </Popconfirm> : null
      }
    ]

    return (
      <div>
        <div className='setting-list'>
          <Skeleton loading={loading} active avatar>
            <List cols={columns} rows={list} />

            <Pager
              size={pageSize}
              total={total}
              totalText={`Total ${total} rate set`}
              current={currentPage}
              onChange={this.changePage}
              style={{ marginTop: '15px' }}
              />
          </Skeleton>
        </div>
        {/*
        <FullModal
          title={settingTitle}
          showModal={modal.show || this.props.onAdd}
          onClose={this.hideModal}
          buttons={[
            <Button key='0' onClick={this.handleSave} feedback={loadingForm}>Save</Button>
          ]}
        >
          <div className='billing-rate-set-rows'>
            <Form>
              <Row>
                <Col lg={12}>
                  <FormItem label='Name' {...formItemLayout}>
                    {getFieldDecorator('name', {
                      initialValue: selectedItem.name,
                      rules: [
                        { min: 2, message: 'Name must be between 2 and 128 characters' },
                        { max: 128, message: 'Name must be between 2 and 128 characters' },
                        { required: true, message: 'Please enter name' },
                        { whitespace: true, message: 'Please enter name' }
                      ]
                    })(
                      <Input />
                    )}
                  </FormItem>
                </Col>
                <Col lg={5}>
                  <FormItem label='Emergency Rate' {...formItemLayout}>
                    {getFieldDecorator('emergency_rate', {
                      initialValue: selectedItem.emergency_rate
                    })(
                      <Input />
                    )}
                  </FormItem>
                  <FormItem label='Enable' {...formItemLayout}>
                    {getFieldDecorator('active', {
                      initialValue: selectedItem.active || true,
                      valuePropName: 'checked'
                    })(
                      <Switch
                        checkedChildren='Enable' unCheckedChildren='Disable'
                      />
                    )}
                  </FormItem>
                </Col>

                <Col lg={7}>
                  <FormItem label='KM Billing Rate' {...formItemTimeLayout}>
                    {getFieldDecorator('km_billing_rate', {
                      initialValue: selectedItem.km_billing_rate
                    })(
                      <Input />
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col lg={6}>
                  <FormItem label='Normal Hours Start' {...formItemTimeLayout}>
                    {getFieldDecorator('normal_hours_start', {
                      initialValue: moment(selectedItem.normal_hours_start)
                    })(
                      <TimePicker use12Hours format='h:mm A' />
                    )}
                  </FormItem>
                </Col>
                <Col lg={6}>
                  <FormItem label='Normal Hours End' {...formItemTimeLayout}>
                    {getFieldDecorator('normal_hours_end', {
                      initialValue: moment(selectedItem.normal_hours_end)
                    })(
                      <TimePicker use12Hours format='h:mm A' />
                    )}
                  </FormItem>
                </Col>
                <Col lg={6}>
                  <FormItem label='After Hours Start' {...formItemTimeLayout}>
                    {getFieldDecorator('after_hours_start', {
                      initialValue: moment(selectedItem.after_hours_start)
                    })(
                      <TimePicker use12Hours format='h:mm A' />
                    )}
                  </FormItem>
                </Col>
                <Col lg={6}>
                  <FormItem label='After Hours End' {...formItemTimeLayout}>
                    {getFieldDecorator('after_hours_end', {
                      initialValue: moment(selectedItem.after_hours_end)
                    })(
                      <TimePicker use12Hours format='h:mm A' />
                    )}
                  </FormItem>
                </Col>
              </Row>
              <SectionTitle title='Rates' />
              <Row gutter={10}>
                <Col lg={10} offset={3}>
                  <b>Normal Hours</b>
                </Col>
                <Col lg={10}>
                  <b>After Hours</b>
                </Col>
              </Row>
              <Row style={{ fontSize: 12, color: '#aaa' }} gutter={10}>
                <Col lg={3}>
                Category
                </Col>
                <Col lg={10}>
                  <Row gutter={4}>
                    <Col lg={3}>
                    Mon
                    </Col>
                    <Col lg={3}>
                    Tue
                    </Col>
                    <Col lg={3}>
                    Wed
                    </Col>
                    <Col lg={3}>
                    Thu
                    </Col>
                    <Col lg={3}>
                    Fri
                    </Col>
                    <Col lg={3}>
                    Sat
                    </Col>
                    <Col lg={3}>
                    Sun
                    </Col>
                    <Col lg={3}>
                    Holiday
                    </Col>
                  </Row>
                </Col>
                <Col lg={10}>
                  <Row gutter={4}>
                    <Col lg={3}>
                    Mon
                    </Col>
                    <Col lg={3}>
                    Tue
                    </Col>
                    <Col lg={3}>
                    Wed
                    </Col>
                    <Col lg={3}>
                    Thu
                    </Col>
                    <Col lg={3}>
                    Fri
                    </Col>
                    <Col lg={3}>
                    Sat
                    </Col>
                    <Col lg={3}>
                    Sun
                    </Col>
                    <Col lg={3}>
                    Holiday
                    </Col>
                  </Row>
                </Col>
              </Row>

              <div className='billing-rate-set-row-list'>
                {
                  categoryRates.map((cat, index) => (
                    <BillingRateRow key={index} item={cat} onChange={(category, day, value) => this.setBillingRate(category, day, value)} onDelete={(category) => this.removeBillingRate(category)} />
                  ))
                }
              </div>
            </Form>
          </div>
        </FullModal> */}
      </div>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchBillingRates({ loading: true, currentPage, filter, sort, searchText })
  }
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(SettingBillingRates))
